module.exports = require('./helpers/bundle-url').getBundleURL('cYku6') + "logo-dark.eefe0b7f.svg";